<style scoped>
.ipt-sty {
  width: 70% !important;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
/deep/ .el-table__expand-icon {
    display: none; 
}
.tab-box{
  display: flex;
  margin-bottom: 25px;
}
.tab-box-list {
  color: #4D4D4D;
  font-size: 16px;
  margin: 0 13px;
  cursor: pointer;
  position: relative;
}
.tab-box-active {
  color: #232323;
}
.tab-box-active .tab-box-line {
  width: 80%;
  height: 3px;
  background: #4fa1a4;
  margin-top: 4px;
  position: absolute;
  left: 10%;
}
.total-tip{
  text-align: right;
  margin: 0 0 16px 0;
}
.total-tip span{
  color: #4fa1a4;
}
.el-col-8{
  display: flex;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6" style="display:flex;">
          <div class="search-area-div w110">姓名/手机号：</div>
          <el-input size="mini" v-model="page.staffName" class="ipt-sty" placeholder="请输入姓名/手机号" clearable></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">药企名称：</div>
          <el-select
          size="mini"
            v-model="page.tenantGuid"
            placeholder="请选择药企名称"
            class="ipt-sty"
            @change="tenantChange"
            clearable
            filterable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">部门名称：</div>
          <el-select
          size="mini"
            v-model="page.organisationGuid"
            placeholder="请选择部门名称"
            class="ipt-sty"
            clearable
            filterable
            multiple 
            collapse-tags
            @focus="getOrganisation()"
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="t-left">
          <el-button size="mini" type="info" @click="getData(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;padding-top:16px;'">
      <p class="total-tip">共 <span>{{staffTotal}}</span> 人，累计下发任务额为 <span>{{taskSalaryTotal | numDigit}}</span> 元</p>
      <el-table ref="table" :data="tableData" :height="height" stripe border v-loading="loading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="姓名" show-overflow-tooltip header-align="left" align="left" min-width="140"></el-table-column>
        <el-table-column prop="mobileNo" label="手机号" show-overflow-tooltip header-align="left" align="left" min-width="140"></el-table-column>
        <el-table-column prop="sendTenantName" label="所属部门" show-overflow-tooltip header-align="left" align="left" min-width="140">
          <template slot-scope="scope">
            {{scope.row.organisationNames?scope.row.organisationNames.toString():'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别" show-overflow-tooltip header-align="center" align="center" width="70">
          <template slot-scope="scope">
            {{scope.row.sex == 'F' ?'男':'女'}}
          </template>
        </el-table-column>
        <el-table-column prop="age" label="年龄" show-overflow-tooltip header-align="center" align="center" width="70"></el-table-column>

        <el-table-column prop="adeptTerritory" label="擅长区域" show-overflow-tooltip header-align="center" align="center" width="140"></el-table-column>
        <el-table-column prop="adeptDomain" label="擅长领域" show-overflow-tooltip header-align="center" align="center" width="140"></el-table-column>
        <el-table-column prop="platformWorkingTime" label="平台从业时间（天）" show-overflow-tooltip header-align="center" align="center" width="160">
          <template slot-scope="scope">
            {{scope.row.platformWorkingTime}}
          </template>
        </el-table-column>


        <el-table-column prop="taskSalary" label="累计下发任务金额" width="140" show-overflow-tooltip header-align="right" align="right">
          <template slot-scope="scope">
            {{scope.row.taskSalary | numDigit}}
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <a class="txt-color" @click="toDetail(scope.row)">查看详情及收入明细</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff  content-pagination-box"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10,20,50,100,200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentMainHeight: window.innerHeight - 200,
      height: window.innerHeight - 260,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        serviceTenantGuid: localStorage.guid,
        tenantGuid: null,
        organisationGuid: [],
        staffName: null,
      },
      timeLists: [],
      organisationList: [],
      tenantList: [],
      loading:false,
      tableData: [],
      staffTotal:0,
      taskSalaryTotal:0
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getTenantList();
  },
  methods: {
    //获取药企
    getTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    tenantChange(val){
      if(val){
        this.getOrganisationList(val)
      }
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid:v,
        sendTenantGuid:localStorage.guid,
      };
      self.page.organisationGuid = [];
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getOrganisation() {
      if (this.page.tenantGuid == '' || this.page.tenantGuid == null) {
        this.$message.error('请选择药企名称!');
        return;
      }
    },
    changeTab(index, item) {
      this.page.allocateState = item.value;
      this.activeTab = index;
      this.getData(1);
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        serviceTenantGuid: localStorage.guid,
        tenantGuid: null,
        organisationGuid: [],
        staffName: null,
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if(this.timeLists.length>0){
        self.page.leaveStartDate = this.timeLists[0];
        self.page.leaveEndDate = this.timeLists[1];
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-audit/staff/income`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          this.getTotal()
          if(res.data.data.records){
            self.tableData = res.data.data.records;
          }else{
            self.tableData = [];
          }
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    getTotal(){
      if(this.timeLists.length>0){
        this.page.leaveStartDate = this.timeLists[0];
        this.page.leaveEndDate = this.timeLists[1];
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task-audit/staff/income-sum`, this.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffTotal = res.data.data.staffTotal;
          this.taskSalaryTotal = res.data.data.taskSalaryTotal;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    toDetail(row){
      sessionStorage.removeItem('staffData')
      this.$router.push(
        {
          path:'/checkSearchDetail',
          productGuid:this.$route.query.productGuid
        }
      )
      sessionStorage.setItem('staffData',JSON.stringify(row))
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
